import { Header } from '@components/atoms/Header';
import { CommonQuestionsSection } from '@components/organisms/CommonQuestions';

export const LandingPage: React.FC = ({ children }) => {
  return (
    <div className="px-2 md:px-8">
      <Header />
      <div className="w-full flex justify-center py-4 rounded-xl bg-[#F3F6F6]">{children}</div>
      <div className="w-full ">
        <CommonQuestionsSection />
      </div>
    </div>
  );
};
